export const DATABASE_MONITORING_METRIC = {
  IONOS_DBAAS_POSTGRES_INSTANCE_COUNT: 'ionos_dbaas_postgres_instance_count',
  IONOS_DBAAS_POSTGRES_ROLE: 'ionos_dbaas_postgres_role',
  IONOS_DBAAS_POSTGRES_STORAGE_AVAILABLE_BYTES: 'ionos_dbaas_postgres_storage_available_bytes',
  IONOS_DBAAS_POSTGRES_STORAGE_TOTAL_BYTES: 'ionos_dbaas_postgres_storage_total_bytes',
  IONOS_DBAAS_POSTGRES_CONNECTIONS_COUNT: 'ionos_dbaas_postgres_connections_count',
  IONOS_DBAAS_POSTGRES_TRANSACTIONS: 'ionos_dbaas_postgres_transactions:rate2m',
  IONOS_DBAAS_POSTGRES_LOAD5: 'ionos_dbaas_postgres_load5',
  IONOS_DBAAS_POSTGRES_MEMORY_AVAILABLE_BYTES: 'ionos_dbaas_postgres_memory_available_bytes',
  IONOS_DBAAS_POSTGRES_MEMORY_TOTAL_BYTES: 'ionos_dbaas_postgres_memory_total_bytes',
  IONOS_DBAAS_POSTGRES_USER_TABLES_IDX_SCAN: 'ionos_dbaas_postgres_user_tables_idx_scan',
  IONOS_DBAAS_POSTGRES_USER_TABLES_SEQ_SCAN: 'ionos_dbaas_postgres_user_tables_seq_scan',
  IONOS_DBAAS_POSTGRES_CPU_RATE5: 'ionos_dbaas_postgres_cpu_rate5m',
  IONOS_DBAAS_POSTGRES_DISK_IO: 'ionos_dbaas_postgres_disk_io_time_weighted_seconds_rate5m',
};

export const DATABASE_MONITORING_METRIC$ = {
  [DATABASE_MONITORING_METRIC.IONOS_DBAAS_POSTGRES_INSTANCE_COUNT]: {
    title: 'Number of server instances',
    labels: ['contract_number', 'postgres_cluster'],
  },
  [DATABASE_MONITORING_METRIC.IONOS_DBAAS_POSTGRES_ROLE]: {
    title: 'Current role of the instance',
    labels: ['contract_number', 'postgres_cluster', 'instance', 'role'],
  },
  [DATABASE_MONITORING_METRIC.IONOS_DBAAS_POSTGRES_STORAGE_AVAILABLE_BYTES]: {
    title: 'Available storage per instance',
    labels: ['contract_number', 'postgres_cluster', 'instance', 'role'],
  },
  [DATABASE_MONITORING_METRIC.IONOS_DBAAS_POSTGRES_STORAGE_TOTAL_BYTES]: {
    title: 'Total storage per instance',
    labels: ['contract_number', 'postgres_cluster', 'instance', 'role'],
  },
  [DATABASE_MONITORING_METRIC.IONOS_DBAAS_POSTGRES_CONNECTIONS_COUNT]: {
    title: 'Number of connections per instance and state',
    labels: ['contract_number', 'postgres_cluster', 'instance', 'role', 'state'],
  },
  [DATABASE_MONITORING_METRIC.IONOS_DBAAS_POSTGRES_TRANSACTIONS]: {
    // title: 'Per-second average rate of transactions measured over the last 2 minutes',
    title: 'Per-second average rate of transactions (2m rate)',
    labels: ['contract_number', 'postgres_cluster', 'instance', 'role', 'datid', 'datname'],
  },
  [DATABASE_MONITORING_METRIC.IONOS_DBAAS_POSTGRES_LOAD5]: {
    title: 'Linux 5 minute load average per instance',
    labels: ['contract_number', 'postgres_cluster', 'instance', 'role'],
  },
  [DATABASE_MONITORING_METRIC.IONOS_DBAAS_POSTGRES_MEMORY_AVAILABLE_BYTES]: {
    title: 'Available memory per instance',
    labels: ['contract_number', 'postgres_cluster', 'instance', 'role'],
  },
  [DATABASE_MONITORING_METRIC.IONOS_DBAAS_POSTGRES_MEMORY_TOTAL_BYTES]: {
    title: 'Total memory per instance',
    labels: ['contract_number', 'postgres_cluster', 'instance', 'role'],
  },
  [DATABASE_MONITORING_METRIC.IONOS_DBAAS_POSTGRES_USER_TABLES_IDX_SCAN]: {
    title: 'Number of index scans per table',
    labels: ['contract_number', 'postgres_cluster', 'instance', 'role', 'datname', 'relname', 'schemaname'],
  },
  [DATABASE_MONITORING_METRIC.IONOS_DBAAS_POSTGRES_USER_TABLES_SEQ_SCAN]: {
    title: 'Number of sequential scans per table',
    labels: ['contract_number', 'postgres_cluster', 'instance', 'role', 'datname', 'relname', 'schemaname'],
  },
};

export const SYNCHRONIZATION_MODES = {
  ASYNC: 'ASYNCHRONOUS',
  SYNC: 'SYNCHRONOUS',
  STRICT_SYNC: 'STRICTLY_SYNCHRONOUS',
};

export const BACKUP_LOCATIONS = {
  de: 'de',
  'eu-south-2': 'eu-south-2',
  'eu-central-2': 'eu-central-2',
};

export const MONGO_BACKUP_LOCATIONS = {
  ...BACKUP_LOCATIONS,
  'eu-central-3': 'eu-central-3',
};

export const AGP_BACKUP_LOCATIONS = {
  'agp-central-1': 'agp-central-1',
};

export const AGP_MONGO_BACKUP_LOCATIONS = {
  ...AGP_BACKUP_LOCATIONS,
};

export const SYNCHRONIZATION_MODE$ = {
  [SYNCHRONIZATION_MODES.ASYNC]: 'asynchronous',
  [SYNCHRONIZATION_MODES.SYNC]: 'synchronous',
  [SYNCHRONIZATION_MODES.STRICT_SYNC]: 'strictly synchronous',
};

export const STORAGE_TYPES = {
  HDD: 'HDD',
  SSD_PREMIUM: 'SSD Premium',
  SSD_STANDARD: 'SSD Standard',
};

export const DATABASE_TYPES = {
  POSTGRES: 'POSTGRES',
  MONGODB: 'MONGODB',
};

export const MONGODB_EDITIONS = {
  PLAYGROUND: 'playground',
  BUSINESS: 'business',
  ENTERPRISE: 'enterprise',
};

export const MONGODB_LOCATIONS = [
  'de/txl', 'de/fra', 'gb/lhr', 'gb/bhx', 'es/vit', 'us/ewr', 'us/mci', 'fr/par', 'ag/s01', 'ag/s02', 'ag/s03', 'ag/p01', 'ag/p02', 'ag/p03',
];

export const MONGODB_INSTANCE_OPTIONS = [1, 3];
export const MONGODB_PLAYGROUND_INSTANCE_OPTIONS = [1];
export const MONGODB_ENTERPRISE_INSTANCE_OPTIONS = [3, 5, 7];

export const INSTANCE_OPTIONS_BY_EDITION = {
  [MONGODB_EDITIONS.BUSINESS]: MONGODB_INSTANCE_OPTIONS,
  [MONGODB_EDITIONS.PLAYGROUND]: MONGODB_PLAYGROUND_INSTANCE_OPTIONS,
  [MONGODB_EDITIONS.ENTERPRISE]: MONGODB_ENTERPRISE_INSTANCE_OPTIONS,
};

export const DEFAULT_SSD_SIZE = 100;
export const DEFAULT_HDD_SIZE = 2;

export const MONGO_DB_TYPES = {
  SHARDED_CLUSTER: 'sharded-cluster',
  REPLICASET: 'replicaset',
};
